import React, { useEffect, useState } from 'react'
import { api, auth } from '../lib/api'
import DateInput from '../components/DateInput'

const pct = (v) => v == null ? '-' : `${v}%`

export default function Stats() {
  const [view, setView] = useState('daily')
  const [range, setRange] = useState({ from: '', to: '' })
  const [daily, setDaily] = useState([])
  const [staff, setStaff] = useState([])
  const [err, setErr] = useState('')

  async function load() {
    setErr('')
    try {
      if (view === 'daily') setDaily((await api.statsDaily(range)).daily)
      else setStaff((await api.statsStaff(range)).staff)
    } catch (e) { setErr(e.message) }
  }
  useEffect(() => { load() }, [view])

  function exportCsv() {
    const rows = view === 'daily'
      ? [['日期', '跟进量', '跟进中量', '收款量', '收款率', '退款量', '退款率', '激活量', '激活率'],
         ...daily.map(d => [d.date, d.follow_count, d.pending_count, d.paid_count, pct(d.paid_rate), d.refund_count, pct(d.refund_rate), d.activated_count, pct(d.activated_rate)])]
      : [['姓名', '跟进量', '跟进中量', '收款量', '收款率', '退款量', '退款率', '激活量', '激活率'],
         ...staff.map(s => [s.name, s.follow_count, s.pending_count, s.paid_count, pct(s.paid_rate), s.refund_count, pct(s.refund_rate), s.activated_count, pct(s.activated_rate)])]
    const csv = '﻿' + rows.map(r => r.join(',')).join('\n')
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }))
    const a = document.createElement('a')
    a.href = url
    a.download = `统计-${view === 'daily' ? '按日期' : '按员工'}-${new Date().toISOString().slice(0, 10)}.csv`
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <div>
      <div className="card filters">
        <div className="row" style={{ gap: 0 }}>
          <button className={`btn ${view === 'daily' ? 'btn-primary' : ''}`} style={{ borderRadius: '8px 0 0 8px' }}
            onClick={() => setView('daily')}>按日期</button>
          {auth.canManageStaff && (
            <button className={`btn ${view === 'staff' ? 'btn-primary' : ''}`} style={{ borderRadius: '0 8px 8px 0' }}
              onClick={() => setView('staff')}>按员工</button>
          )}
        </div>
        <div className="field">
          <label className="small muted">从</label>
          <DateInput value={range.from} onChange={e => setRange({ ...range, from: e.target.value })} />
        </div>
        <div className="field">
          <label className="small muted">到</label>
          <DateInput value={range.to} onChange={e => setRange({ ...range, to: e.target.value })} />
        </div>
        <button className="btn btn-primary" onClick={load}>查询</button>
        <button className="btn" onClick={() => { setRange({ from: '', to: '' }) }}>重置</button>
        <div style={{ marginLeft: 'auto' }}>
          <button className="btn" onClick={exportCsv}>导出</button>
        </div>
      </div>

      <div className="card table-wrap">
        {view === 'daily' ? (
          <table>
            <thead>
              <tr><th>日期</th><th>跟进量</th><th>跟进中量</th><th>收款量</th><th>收款率</th><th>退款量</th><th>退款率</th><th>激活量</th><th>激活率</th></tr>
            </thead>
            <tbody>
              {daily.map(d => (
                <tr key={d.date}>
                  <td>{d.date}</td><td>{d.follow_count}</td><td>{d.pending_count}</td>
                  <td>{d.paid_count}</td><td>{pct(d.paid_rate)}</td>
                  <td>{d.refund_count}</td><td>{pct(d.refund_rate)}</td>
                  <td>{d.activated_count}</td><td>{pct(d.activated_rate)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <table>
            <thead>
              <tr><th>姓名</th><th>跟进量</th><th>跟进中量</th><th>收款量</th><th>收款率</th><th>退款量</th><th>退款率</th><th>激活量</th><th>激活率</th></tr>
            </thead>
            <tbody>
              {staff.map(s => (
                <tr key={s.id}>
                  <td>{s.name}</td><td>{s.follow_count}</td><td>{s.pending_count}</td>
                  <td>{s.paid_count}</td><td>{pct(s.paid_rate)}</td>
                  <td>{s.refund_count}</td><td>{pct(s.refund_rate)}</td>
                  <td>{s.activated_count}</td><td>{pct(s.activated_rate)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {view === 'daily' && !daily.length && <div className="empty">暂无数据</div>}
        {view === 'staff' && !staff.length && <div className="empty">暂无数据</div>}
      </div>
      <div className="err">{err}</div>
    </div>
  )
}
